export const genRandomInt = (min: number, max: number): number => {
    const theMin = Math.ceil(min);
    const theMax = Math.floor(max);
    return Math.floor(Math.random() * (theMax - theMin)) + theMin;
};

export const throttle = (func: Function, wait: number): Function => {
    let timeout: ReturnType<typeof setTimeout>;
    // Todo: 考虑是否需要记录列表
    let id: number = -1;
    return function (...args: any[]) {
        let args0 = args[0];
        if (!timeout && id !== args0) {
            id = args0;
            timeout = setTimeout(() => {
                func(...args);
                clearTimeout(timeout);
                id = -1;
            }, wait);
        }
    };
}
